import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from "react";
const MountainIcon = _ref => {
  let {
      size = "16",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({}, attributes, {
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), __jsx("path", {
    d: "M8.41603 0.22265C8.32329 0.0835506 8.16718 0 8 0C7.83282 0 7.67671 0.0835506 7.58398 0.22265L4.58398 4.72265C4.48169 4.87608 4.47215 5.07335 4.55916 5.23593C4.64617 5.39851 4.8156 5.5 5 5.5H5.09788L3.076 8.735C2.97967 8.88914 2.97457 9.08341 3.06268 9.24238C3.15079 9.40136 3.31824 9.5 3.5 9.5H3.69098L2.05279 12.7764C1.97529 12.9314 1.98357 13.1155 2.07468 13.2629C2.16578 13.4103 2.32671 13.5 2.5 13.5H7L7 16H9V13.5H13.5C13.6733 13.5 13.8342 13.4103 13.9253 13.2629C14.0164 13.1155 14.0247 12.9314 13.9472 12.7764L12.309 9.5H12.5C12.6818 9.5 12.8492 9.40136 12.9373 9.24238C13.0254 9.08341 13.0203 8.88914 12.924 8.735L10.9021 5.5H11C11.1844 5.5 11.3538 5.39851 11.4408 5.23593C11.5278 5.07335 11.5183 4.87608 11.416 4.72265L8.41603 0.22265Z",
    fill: "#757474"
  }));
};
export default MountainIcon;